import { render, staticRenderFns } from "./DiagnosisCodeICDCodeCrud.vue?vue&type=template&id=0bd8c4c8&"
import script from "./DiagnosisCodeICDCodeCrud.vue?vue&type=script&lang=js&"
export * from "./DiagnosisCodeICDCodeCrud.vue?vue&type=script&lang=js&"
import style0 from "./DiagnosisCodeICDCodeCrud.vue?vue&type=style&index=0&id=0bd8c4c8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports